/* eslint-disable jsx-a11y/label-has-associated-control */
import { Empty, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
// import InputMask from 'react-input-mask';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { log } from 'utils';
import 'react-quill/dist/quill.snow.css';
import './AddWebLayoutConfigForm.css';

import { EmptyIcon } from 'assets/icon/bigicon';
import AddMediaIcon from '../../../assets/icon/add-media.png';
import { toastr } from 'react-redux-toastr';
import { imgUrl } from 'utils/url';
import { addWebLayout, updateWebLayout } from 'state/actions/webLayout';
import { fetchWebMenus } from 'state/actions/webMenus';
import { fetchMediaCategories } from 'state/actions/mediaCategories';
import { fetchCategories } from 'state/actions/categories';

const AddWebLayoutConfigForm = ({ error, onClose, predefinedData }) => {
  const { siteId, siteName } = useParams();
  const [editingSection, setEditingSection] = useState(null);
  const { Option } = Select;
  log(error);

  const [errors, setErrors] = useState(error);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const {
    loading,
    userData,
    webMenus,
    mediaCategories,
    poiCategory,
    informationCategoriesList,
  } = useSelector(
    (state) => ({
      loading: state.information.loading,
      userData: state.auth.userData,
      webMenus: state.webMenus.list,
      mediaCategories: state.mediaCategories.list,
      poiCategory: state.categories.list,
      informationCategoriesList: state.informationCategories.list,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (predefinedData) {
      setLayoutTemplateID(predefinedData.templateId || '');
      setTitleTemplate(predefinedData.title || '');

      if (predefinedData.content) {
        const mappedSections = predefinedData.content.map((sec) => ({
          id: Date.now() + Math.random(),
          sectionId: sec.type,
          title: sec.variable,
          content: '',
          template: null,
          button: {},
          image: null,
          file: null,
          required: sec.isRequired || false,
          menuId: sec.menuId || '',
          poiCategoryId: sec.poiCategoryId || '',
          mediaCategoryId: sec.mediaCategoryId || '',
          informationCategoryId: sec.informationCategoryId || '',
          notes: sec.notes || '',
        }));

        setSections(mappedSections);
      }

      // image
      if (predefinedData.logo) {
        setMediaFiles([
          {
            id: Date.now(),
            name: 'existing',
            preview: `${imgUrl}/media/${predefinedData.logo}`,
            file: null,
          },
        ]);
      }
    }
  }, [predefinedData]);

  const dispatch = useDispatch();

  const [sections, setSections] = useState([]);

  const isEdit = predefinedData && predefinedData._id;

  const [columnOne, setColumnOne] = useState('80%');

  const [openAddSection, setOpenAddSection] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [layoutTemplateID, setLayoutTemplateID] = useState('');
  const [titleTemplate, setTitleTemplate] = useState('');

  const [variableName, setVariableName] = useState('');
  const [variableType, setVariableType] = useState('');
  const [isRequired, setIsRequired] = useState(false);
  const [variableNotes, setVariableNotes] = useState('');

  const [mediaFiles, setMediaFiles] = useState([]);
  const [selectedMenuForLayout, setSelectedMenuForLayout] = useState('');
  const [selectedPoiCategory, setSelectedPoiCategory] = useState('');
  const [selectedMediaCategory, setSelectedMediaCategory] = useState('');
  const [selectedInformationCategory, setSelectedInformationCategory] =
    useState('');

  const handleMediaChange = (e) => {
    const files = Array.from(e.target.files);

    const mappedFiles = files.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      name: file.name,
      preview: URL.createObjectURL(file),
    }));

    setMediaFiles((prev) => [...prev, ...mappedFiles]);
  };

  useEffect(() => {
    if (siteId) {
      dispatch(fetchWebMenus({ siteId }));
      dispatch(fetchCategories({ siteId }));
      dispatch(fetchMediaCategories({ siteId }));
    }
  }, [siteId]);

  const handleCreateWebLayout = async () => {
    try {
      const formData = new FormData();

      formData.append('title', titleTemplate);
      formData.append('templateId', layoutTemplateID);
      formData.append('siteId', siteId);
      formData.append('userId', userData.id);
      console.log(sections, 'section 1223s');
      const mappedContent = sections.map((sec) => ({
        variable: sec.title,
        type: sec.sectionId,
        notes: sec.notes || '',
        isRequired: sec.required || false,
        menuId: sec.menuId,
        poiCategoryId: sec.poiCategoryId,
        mediaCategoryId: sec.mediaCategoryId,
        informationCategoryId: sec.informationCategoryId,
      }));

      formData.append('content', JSON.stringify(mappedContent));

      // image
      if (mediaFiles.length > 0 && mediaFiles[0].file) {
        formData.append('file', mediaFiles[0].file);
      }

      if (isEdit) {
        onClose();
        dispatch(
          updateWebLayout(predefinedData._id, formData, () => onClose())
        );
      } else {
        dispatch(addWebLayout(formData, () => onClose()));
      }
    } catch (err) {
      console.log(err);
      toastr.error('Error', 'Something went wrong');
    }
  };

  const handleRemoveSection = (id) => {
    setSections((prev) => prev.filter((section) => section.id !== id));
  };

  const handleEditSection = (section) => {
    setEditingSection(section);
    setSelectedTemplate(section);

    setVariableName(section.title);
    setVariableType(section.sectionId);
    setVariableNotes(section.notes || '');
    setIsRequired(section.required || false);
    setSelectedMenuForLayout(section.menuId || '');
    setSelectedPoiCategory(section.poiCategoryId || '');
    setSelectedMediaCategory(section.mediaCategoryId || '');
    setSelectedInformationCategory(section.informationCategoryId || '');
    setOpenAddSection(true);
  };

  const handleAddContent = () => {
    if (!variableName || !variableType) return;

    if (editingSection) {
      const updatedSections = sections.map((sec) =>
        sec.id === editingSection.id
          ? {
              ...sec,
              title: variableName,
              sectionId: variableType,
              notes: variableNotes,
              required: isRequired,
              menuId: selectedMenuForLayout,
              poiCategoryId: selectedPoiCategory,
              mediaCategoryId: selectedMediaCategory,
              informationCategoryId: selectedInformationCategory,
            }
          : sec
      );
      setSections(updatedSections);
      setEditingSection(null);
    } else {
      const newSection = {
        id: Date.now(),
        sectionId: variableType,
        title: variableName,
        notes: variableNotes,
        content: '',
        template: null,
        button: {},
        image: null,
        file: null,
        required: isRequired,
        menuId: selectedMenuForLayout,
        poiCategoryId: selectedPoiCategory,
        mediaCategoryId: selectedMediaCategory,
        informationCategoryId: selectedInformationCategory,
      };

      setSections((prev) => [...prev, newSection]);
    }

    // reset form
    setVariableName('');
    setVariableType('');
    setVariableNotes('');
    setIsRequired(false);
    setSelectedMenuForLayout('');
    setSelectedPoiCategory('');
    setSelectedMediaCategory('');
    setSelectedInformationCategory('');
  };

  const sectionOne = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: '80%',
            height: '100vh',
          }}
        >
          <form className="form-wrapper">
            <div>
              <div className="form">
                <label className="form-label">
                  Template ID <span className="is-required">*</span>
                </label>
                <Input
                  placeholder="Enter Title"
                  className={`${
                    errors && errors.errors && errors.errors.name
                      ? 'has-error'
                      : ''
                  }`}
                  name="name"
                  value={layoutTemplateID}
                  onChange={(e) => setLayoutTemplateID(e.target.value)}
                />
                {errors && errors.errors && errors.errors.name && (
                  <span className="error-message">
                    {errors.errors.name[0].msg}
                  </span>
                )}
              </div>

              <div className="form">
                <label className="form-label">Title</label>
                <Input
                  placeholder="Enter Title"
                  name="title"
                  type="text"
                  value={titleTemplate}
                  onChange={(e) => setTitleTemplate(e.target.value)}
                />
                {errors &&
                  errors.errors &&
                  errors.errors.title &&
                  errors.errors.title.map((name, idx) => (
                    <div className="error-message" key={idx}>
                      {name.msg}
                    </div>
                  ))}
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginBottom: '16px',
                }}
              >
                <input
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  id="media-upload"
                  style={{ display: 'none' }}
                  onChange={handleMediaChange}
                />

                <div
                  onClick={() =>
                    document.getElementById('media-upload').click()
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '6px 10px',
                    fontSize: '12px',
                    color: '#64D5D2',
                    backgroundColor: 'white',
                    border: '1px solid #64D5D2',
                    borderRadius: '4px',
                    cursor: 'pointer',
                  }}
                >
                  <img
                    src={AddMediaIcon}
                    style={{
                      width: '20px',
                      height: '20px',
                    }}
                  />
                  Add Layout Image
                </div>
              </div>

              {mediaFiles.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                  <div
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
                  >
                    {mediaFiles.map((media) => (
                      <div
                        key={media.id}
                        style={{
                          position: 'relative',
                          width: '100px',
                          height: '100px',
                          border: '1px solid #e5e7eb',
                          borderRadius: '6px',
                          overflow: 'hidden',
                        }}
                      >
                        <img
                          src={media.preview}
                          alt={media.name}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                        />
                        <button
                          onClick={() =>
                            setMediaFiles((prev) =>
                              prev.filter((m) => m.id !== media.id)
                            )
                          }
                          style={{
                            position: 'absolute',
                            top: '4px',
                            right: '4px',
                            background: 'red',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            cursor: 'pointer',
                            fontSize: '12px',
                          }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="form">
                <div className="label-content">
                  <label
                    className="form-label"
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    Content
                  </label>
                  <label
                    className="form-label"
                    style={{
                      color: '#64D5D2',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                    onClick={handleAddContent}
                  >
                    {editingSection ? 'Update Content' : '+ Add Content'}
                  </label>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    marginBottom: '20px',
                    marginTop: '16px',
                  }}
                >
                  <div className="form">
                    <label className="form-label">Variable</label>
                    <Input
                      placeholder="Enter Title"
                      className={`${
                        errors && errors.errors && errors.errors.name
                          ? 'has-error'
                          : ''
                      }`}
                      name="name"
                      value={variableName}
                      onChange={(e) => setVariableName(e.target.value)}
                    />
                    {errors && errors.errors && errors.errors.name && (
                      <span className="error-message">
                        {errors.errors.name[0].msg}
                      </span>
                    )}
                  </div>

                  <div
                    className="form"
                    style={{
                      width: '220px',
                    }}
                  >
                    <label className="form-label">Type</label>
                    <Select
                      value={variableType || undefined}
                      onChange={(value) => setVariableType(value)}
                      placeholder="Select Type"
                      className="custom-select"
                      style={{ width: '210px' }}
                    >
                      <Option value="title">Title</Option>
                      <Option value="paragraph">Paragraph</Option>
                      <Option value="image">Image</Option>
                      <Option value="button">Button</Option>
                      <Option value="menus">Menu</Option>
                      <Option value="tenants">Tenants</Option>
                      <Option value="medias">Medias</Option>
                      <Option value="information">Information</Option>
                      <Option value="notes">Notes</Option>
                    </Select>
                  </div>
                  {variableType === 'menus' && (
                    <div
                      className="form"
                      style={{
                        width: '220px',
                      }}
                    >
                      <label className="form-label">Select Menu</label>
                      <Select
                        value={selectedMenuForLayout || undefined}
                        onChange={(value) => setSelectedMenuForLayout(value)}
                        placeholder="Select Type"
                        className="custom-select"
                        style={{ width: '210px' }}
                      >
                        {webMenus
                          ?.filter(
                            (menu) => menu.menuSettings.displayLocation.footer
                          )
                          ?.map((menu) => (
                            <Option value={menu._id}>{menu.title}</Option>
                          ))}
                      </Select>
                    </div>
                  )}
                  {variableType === 'tenants' && (
                    <div
                      className="form"
                      style={{
                        width: '220px',
                      }}
                    >
                      <label className="form-label">
                        Select Tenant Category
                      </label>
                      <Select
                        value={selectedPoiCategory || undefined}
                        onChange={(value) => setSelectedPoiCategory(value)}
                        placeholder="Select Poi Category"
                        className="custom-select"
                        style={{ width: '210px' }}
                      >
                        {poiCategory?.map((cat) => (
                          <Option value={cat._id}>{cat.name}</Option>
                        ))}
                      </Select>
                    </div>
                  )}
                  {variableType === 'medias' && (
                    <div
                      className="form"
                      style={{
                        width: '220px',
                      }}
                    >
                      <label className="form-label">
                        Select Media Category
                      </label>
                      <Select
                        value={selectedMediaCategory || undefined}
                        onChange={(value) => setSelectedMediaCategory(value)}
                        placeholder="Select Media Category"
                        className="custom-select"
                        style={{ width: '210px' }}
                      >
                        {mediaCategories?.map((cat) => (
                          <Option value={cat._id}>{cat.name}</Option>
                        ))}
                      </Select>
                    </div>
                  )}
                  {variableType === 'information' && (
                    <div
                      className="form"
                      style={{
                        width: '220px',
                      }}
                    >
                      <label className="form-label">
                        Select Infromation Category
                      </label>
                      <Select
                        value={selectedInformationCategory || undefined}
                        onChange={(value) =>
                          setSelectedInformationCategory(value)
                        }
                        placeholder="Select Information Category"
                        className="custom-select"
                        style={{ width: '210px' }}
                      >
                        {informationCategoriesList?.map((cat) => (
                          <Option value={cat._id}>{cat.name}</Option>
                        ))}
                      </Select>
                    </div>
                  )}
                  {variableType === 'notes' && (
                    <div className="form">
                      <label className="form-label">Notes</label>
                      <Input
                        value={variableNotes}
                        placeholder="Enter Notes"
                        style={{
                          borderColor: '#1677ff',
                        }}
                        onChange={(e) => setVariableNotes(e.target.value)}
                      />
                    </div>
                  )}

                  {/* Required */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '18px',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isRequired}
                      onChange={(e) => setIsRequired(e.target.checked)}
                    />
                    <span style={{ marginLeft: '6px' }}>Required</span>
                  </div>
                </div>

                {sections.length === 0 ? (
                  <div className="web-page-empty">
                    <Empty image={<EmptyIcon />} description="No Config" />
                  </div>
                ) : (
                  <div className="section-list">
                    {sections.map((section) => (
                      <div
                        key={section.id}
                        className="section-item"
                        onClick={() => handleEditSection(section)}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '8px 12px',
                          border:
                            editingSection?.id === section.id
                              ? '2px solid #64D5D2'
                              : '1px solid #eee',
                          borderRadius: '4px',
                          marginBottom: '8px',
                          background: '#fff',
                        }}
                      >
                        <div>
                          {section.template && (
                            <img
                              src={
                                section.file?.[0]?.preview ||
                                (section.image
                                  ? `${imgUrl}/media/${section.image}`
                                  : null) ||
                                section.template?.image
                              }
                              alt={section.template.name}
                              style={{
                                width: '60px',
                                height: '40px',
                                objectFit: 'cover',
                                borderRadius: '4px',
                                border: '1px solid #eee',
                              }}
                            />
                          )}
                          <div style={{ fontWeight: 600 }}>{section.title}</div>
                          <div style={{ fontSize: '12px', color: '#888' }}>
                            {section.sectionId}
                          </div>
                          {section.notes && (
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#666',
                                marginTop: '4px',
                                maxWidth: '500px',
                              }}
                            >
                              Notes: {section.notes}
                            </div>
                          )}
                          <div style={{ fontSize: '12px', color: '#888' }}>
                            {section.menuId && `Menu: ${section.menuId}`}
                            {section.poiCategoryId &&
                              ` | Poi: ${section.poiCategoryId}`}
                            {section.mediaCategoryId &&
                              ` | Media: ${section.mediaCategoryId}`}
                            {section.informationCategoryId &&
                              ` | Information: ${section.informationCategoryId}`}
                          </div>
                        </div>

                        <button
                          type="button"
                          className="button-secondary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveSection(section.id);
                          }}
                          style={{
                            background: '#ff4d4f',
                            color: 'white',
                            border: 'none',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </form>
          <div
            className="button-wrapper"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <div>
              {loading ? (
                <button className="button-primary" disabled>
                  Loading...
                </button>
              ) : (
                <button className="btn-primary" onClick={handleCreateWebLayout}>
                  {isEdit ? 'Update' : 'Submit'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        padding: '12px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            fontSize: '24px',
            fontWeight: 700,
          }}
        >
          Add Layout Config
        </span>
        <div
          style={{
            top: '0',
            right: '0',
            position: 'absolute',
          }}
          onClick={onClose}
          className="button-secondary"
        >
          <i className="feather-arrow-left" />
          Back
        </div>
      </div>

      <div className="addWebPagesForm">{sectionOne()}</div>
    </div>
  );
};

export default AddWebLayoutConfigForm;
